export default __webpack_public_path__ + "static/festl-ruhpolding-2024-preview-3820dfb4aa71a5bc405267b5fcb921c0.jpg";